<template>
	<div class="Recruiting">
		<div class="partOne">
			<div class="inner-box">
				<div class="mshcn">
					<div class="dot"></div>
					<div class="txt">61MSH.COM</div>
				</div>
				<div class="mshcnkj">谋生活招聘</div>
				<div class="item"><span>➣</span>谋生活招聘</div>
				<div class="item"><span>➣</span>快招工准结算、更合规</div>
				<div class="item"><span>➣</span>助力灵活就业者快速匹配合适岗位</div>
				<div class="imgBox">
					<img alt="" src="../assets/images/zhaopin.png" width="710" height="400">
				</div>
			</div>
		</div>
		<div class="textcenter">
			<div class="tc-phone">
				<div style="margin: 0 15px;"><i class="fa fa-phone" style="font-size: 25px;font-style: normal;"></i>
				</div>
				<span>400-700-9161</span>
			</div>
			<h3>
				灵活就业及企业用工灵活化服务SaaS服务平台
			</h3>
		</div>
		<div class="partTwo">
			<div class="inner-box">
				<div class="Box">
					<div class="leftBox">
						<img src="../assets/images/banner/bg_4.jpg"  alt="谋生活招聘">
						<!-- <img src="../assets/images/img/iphone-bg.png" height="566" width="380" /> -->
					</div>
					<div class="rightBox">
						<div class="url">61MSH.COM</div>
						<div class="one">
							<span class="frozen" data-heading="Frozen">谋生活招聘服务</span>
						</div>
						<div class="two"></div>
						<div class="txt">
							专注于为蓝灰领提供城市服务类一线岗位的招聘平台，服务于酒店餐饮合作商户，帮助他们解决「招人难 用工难」的问题
						</div>
						<div class="box">
							<div class="item">
								<div class="txt1">
									<span style="margin-right: 10px;">➣</span>多重审核
								</div>
								<div class="txt2">谋生活招聘的信息经过多重审核，层层过滤虚假信息，招聘企业经过实名认证、实地认证，安全可靠</div>
							</div>
							<div class="item">
								<div class="txt1">
									<span style="margin-right: 10px;">➣</span>商业保险
								</div>
								<div class="txt2">谋生活招聘为兼职者推出多种商业保险，为企业的用工与人员的安全保驾护航，赔付额度最高达80万</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<my-footer></my-footer>
	</div>
</template>

<script>
	export default {
		name: 'Recruiting',
		created() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	@font-face {
		font-family: "frozen";
		src: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/209981/Ice%20kingdom%20-%20Bold%20-%20Por%20Kustren.woff");
	}

	.Recruiting {
		background-color: rgb(255, 255, 255);
		height: 100%;
		/* margin-top: 50px; */
	}

	.partOne {
		height: 335px;
		background-color: #f9fafc;
		position: relative;
		/* margin: 0 0 2%; */
		padding-top: 6%;
	}

	.partOne .mshcn {
		margin-left: 11%;
		margin-bottom: 15px;
		display: flex;
		align-items: center;
	}

	.partOne .mshcn .dot {
		width: 12px;
		height: 12px;
		background-color: #ff8400;
		border-radius: 50%;
		margin-right: 10px;
	}

	.partOne .mshcn .txt {
		width: 84px;
		height: 20px;
		font-family: "frozen", serif;
		font-size: 18px;
		color: #ff8400;
		font-weight: 700;
	}

	.partOne .mshcnkj {
		margin-left: 11%;
		font-size: 40px;
		color: #0d1d34;
		font-weight: 600;
		position: relative;
		margin-bottom: 50px;
	}

	.partOne .mshcnkj::before {
		content: "";
		width: 104px;
		height: 2px;
		background-color: #e6e6e6;
		position: absolute;
		left: 70px;
		bottom: -15px;
	}

	.partOne .mshcnkj::after {
		content: "";
		width: 70px;
		height: 4px;
		background: #ff8500;
		border-radius: 2px;
		position: absolute;
		left: 0px;
		bottom: -16px;
	}

	.partOne .item {
		margin-left: 11%;
		display: flex;
		align-items: center;
		line-height: 40px;
		font-size: 14px;
		color: #6e748c;
		font-weight: 400;
	}

	.partOne .imgBox {
		position: absolute;
		right: -15%;
		top: -6%;
		margin-top: -5%;
		animation: contentFromRight2Left .6s ease-out;
	}

	.textcenter {
		background-color: #ff8400;
		color: #fff;
		text-align: center;
		padding: 20px 0 20px;
		border: 1px solid #eff2f8;
		/* background: url(../views/svg.png) no-repeat center; */
	}

	.textcenter .tc-phone {
		margin: 20px 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.textcenter .tc-phone span {
		font-size: 28px;
		/* font-family: "frozen", serif; */
		/* font-family: PingFangSC-Medium, PingFang SC; */
		font-weight: 500;
		/* color: #ffffff; */
		line-height: 40px;
	}

	.textcenter h3 {
		margin: 20px 0;
		font-size: 28px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		/* color: #ffffff; */
		line-height: 45px;
	}

	.partTwo {
		height: 535px;
		/* background-color: #f9fafc; */
		display: flex;
		flex-direction: column;
		position: relative;
		margin-top: 30px;
	}

	.partTwo .inner-box .Box {
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.partTwo .inner-box .leftBox {
		width: 444px;
		/* height: 535px; */
		text-align: center;
		z-index: 999;
		box-shadow: 0px 0px 10px 10px #eff2f8;
		border-radius: 8px;
		margin: 10px 0 3vw;
	}

	.partTwo .inner-box .rightBox {
		width: 700px;
		height: 380px;
	}

	.frozen {
		/* 最初字体样式 */
		font-size: 30px;
		font-weight: 400;
		margin-left: 20px;
		/* 使用自定义字体 */
		/* font-family: "frozen", serif; */
		/* 设置背景图片 */
		/* background: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/209981/6963bbf342d87b3a2150bd8f59682b89.jpg); */
		/* 设置文字透明且背景按文字区域裁剪 */
		/* color: transparent; */
		color: #252627;
		-webkit-background-clip: text;
		/* 为了子元素定位 */
		position: relative;
	}

	.frozen::before {
		/* 获取自定义属性文字 */
		content: attr(data-heading);
		/* 使其和父元素文字重叠 */
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		/* 使用颜色混合模式 */
		mix-blend-mode: screen;
		/* 文字透明 */
		color: transparent;
		/* 设置文字阴影 */
		text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2), -2px 2px 10px rgba(0, 0, 0, 0.2), -2px -2px 10px rgba(0, 0, 0, 0.2);
		/* 设置渐变背景 */
		background: linear-gradient(45deg, rgba(255, 255, 255, 0) 45%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0) 55%, rgba(255, 255, 255, 0) 100%);
		background-size: 200%;
		/* 使用背景图动画 */
		animation: glare 1s infinite;
	}

	/* 设置背景图动画 */
	@keyframes glare {
		0% {
			background-position: -100%;
		}

		100% {
			background-position: 100%;
		}
	}

	.url {
		font-family: "frozen", serif;
		font-size: 43px;
		-webkit-text-stroke: 1px #ff8500;
		-webkit-text-fill-color: white;
		color: white;
		opacity: 0.5;
		margin: 10px 20px;
	}

	.partTwo .inner-box .rightBox .two {
		top: 10px;
		width: 330px;
		height: 1px;
		background-image: linear-gradient(269deg, #ff8500, rgba(255, 133, 0, 0));
		margin-left: -50px;
		margin-bottom: 20px;
		position: relative;
	}

	.partTwo .inner-box .rightBox .two::before {
		width: 9px;
		height: 9px;
		background: #ff8500;
		content: "";
		position: absolute;
		top: -4px;
		right: 0;
	}

	.partTwo .inner-box .rightBox .txt {
		width: 648px;
		height: 60px;
		font-size: 18px;
		color: #252627;
		line-height: 30px;
		font-weight: 200;
		margin: 39px 0 40px;
	}

	.partTwo .inner-box .rightBox .box {
		display: flex;
		justify-content: space-between;
	}

	.partTwo .inner-box .rightBox .box .item {
		width: 330px;
	}

	.partTwo .inner-box .rightBox .box .item .txt1 {
		line-height: 22px;
		font-size: 16px;
		color: #1c1c1c;
		font-weight: 600;
		display: flex;
		align-items: center;
	}

	.partTwo .inner-box .rightBox .box .item .txt2 {
		height: 60px;
		font-size: 14px;
		color: #6d758a;
		line-height: 30px;
		font-weight: 400;
		margin-top: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/page/Recruiting.vue